import React from 'react';
import BackRoundButton from '../../../framework/forms/helpercomponents/buttons/BackRoundButton';
import AddRoundButton from '../../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { utility } from '../../../framework/utility/utilityProvider';
import { PLAYLIST_STATUS } from '../../../framework/constant/constant';
import MobileGridCard from './MobileGridCard';
import { useNavigate } from 'react-router-dom';
import MyStatusCell from '../../../components/MyStatusCell';
import { ContentArrayImageCell } from '../../../framework/forms/helpercomponents/CustomGridCells/ContentArrayImageCell';
import { Loader } from '../../../framework/forms/helpercomponents/Loader';

export const DigitalSignMobileSchedulePlaylistCollection = (props) => {

    const { gridData = [],  isLoading, onEnterEdit, handleDelete, onAdd, refreshCollection } = props;
    const navigate = useNavigate();

    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                 <h1 className="page-title txt-color-bludeDark">
                        <i className="fa fa-table marlr" style={{ fontSize: "20px", color: "GrayText" }}></i>
                        <span>Schedule Playlist</span>
                    </h1>
            <div className="flex-container mt-2 mb-2">
                    <BackRoundButton onClick={() => navigate(-1)}></BackRoundButton>
                    <AddRoundButton  onClick={onAdd}/>
            </div>
            {isLoading ? <Loader /> :
                <div className='mb-5' style={{ flex: 1, overflowY: "auto" }}>
                    {gridData.length == 0 ?
                        <div style={{ height: "65vh", display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', fontWeight: "500", color: "grey" }}>
                            <AddRoundButton /> Add Playlist
                        </div>
                        : gridData.map((item, index) => {
                            console.log(item);
                            const contextMenuItem = [
                                {
                                    label: 'Edit',
                                    command: (e) => { e.originalEvent.stopPropagation(); onEnterEdit(item) },
                                    icon: 'pi pi-pencil'
                                },
                                {
                                    label: 'Refresh',
                                    command: (e) => { e.originalEvent.stopPropagation(); refreshCollection(item) },
                                    icon: 'pi pi-refresh'
                                },
                                {
                                    label: 'Delete',
                                    command: (e) => { e.originalEvent.stopPropagation(); handleDelete(item) },
                                    icon: 'pi pi-trash'
                                }
                            ]
                            return <MobileGridCard
                                key={index}
                                title={item.Name}
                                topRight={utility.convertMilisecondsToLocalDateTime(item.Schedule.StartDate)}
                                description={item?.screenGroup?.map(x => x?.Name)?.join(', ')}
                                label2={<ContentArrayImageCell field="playlistItem" dataItem={item} />}
                                label1={<MyStatusCell titleFontSize='10px' titleHeight='20px' style={{ width: '60px', position: "relative" }} title={utility.convertCamelCaseToWords(utility.getKeyByValue(PLAYLIST_STATUS, item.Status))} tileBackColor="#508D4E" />}
                                bottomRight={utility.convertMilisecondsToLocalDateTime(item.Schedule.EndDate)}
                                label2Style={{ marginLeft: '-10px', marginTop: '10px' }}
                                contextMenuItem={contextMenuItem}
                                showContextMenu={true}
                                data={item}
                                handleItemClick={onEnterEdit}
                                height='150px'
                            />
                        })}
                </div>
            }
        </div>
    )
}